import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ContentBlock extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      title,
      description,
      isScrollable
    } = this.props;

    return (
      description ?
        <section className={`fe-trip-addinfo ${(isScrollable) ? 'scrollable' : ''}`}>
          <div className="container">
            <div className="row position-relative">
              {/* <div className="col-lg-8"> */}
              {title ? (<h4 className="fe-trip-main-heading">{ title }</h4>) : null}
              {/* <div
                className="fe-trip-addinfo-content"
                dangerouslySetInnerHTML={{__html: description}}
              /> */}
              <div className="fe-trip-addinfo-content">
                For cancellations and refunds, please read the terms and conditions listed in our <a href="/getaways/faq" target="_blank">Frequently Asked Questions (FAQ)</a>.
              </div>
              {/* </div> */}
            </div>
          </div>
        </section> :
        null
    );
  }
}

ContentBlock.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  isScrollable: PropTypes.bool
};

export default ContentBlock;
